import { lazy } from 'react';
export const ViewDevicePackage = lazy(() => import('@/Portal/DevicePackages/ViewDevicePackage'));
export const DevicePackages = lazy(() => import('@/Portal/DevicePackages/DevicePackages'));
export const ViewDevicePackageGroup = lazy(() => import('@/Portal/DevicePackageGroups/ViewDevicePackageGroup'));
export const DevicePackageGroups = lazy(() => import('@/Portal/DevicePackageGroups/DevicePackageGroups'));
